import {
  DateField,
  useRecordContext,
  RecordContextProvider,
  useTranslate,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

const TransactionHistoryExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <Paper
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          // bgcolor: "rgba(0,0,0,.04)",
          // fontSize: "smaller",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "6px 8px",
            border: "1px solid #dddddd",
          },
        }}
      >
        <thead>
          <tr>
            <th>{t("mine.label.created_at")}</th>
            <th>{t("mine.label.note")}</th>
            <th>User</th>
          </tr>
        </thead>
        <tbody>
          {record.activities.map((item, idx) => {
            return (
              <tr key={item.id + idx}>
                <td>
                  <RecordContextProvider value={item}>
                    <DateField
                      source="created_at" // FIXME: Jangan pakai created at
                      sx={{
                        fontSize: "inherit",
                      }}
                      options={{
                        year: "numeric",
                        month: "short",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                      }}
                      showTime
                    />
                  </RecordContextProvider>
                </td>
                <td>
                  <RecordContextProvider value={item}>
                    <TextField
                      source="note"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td>
                  <RecordContextProvider value={item}>
                    <TextField
                      source="user.username"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Paper>
  );
};

export default TransactionHistoryExpandList;
